import React, {useState} from 'react';
import Video from '../../videos/video.mp4' ;
import { Button } from '../ButtonElement';
import { HeroContainer, HeroBg, VideoBg, HeroContent, HeroH1, HeroP, HeroBtnWrapper, ArrowForward, ArrowRight } from './HeroElements';
import Typed from "react-typed";

export const HeroSection = () => {
  const [hover, setHover ] = useState(false);

  const onHover = () => setHover(!hover);

  return (
    <HeroContainer id="home">
      <HeroBg>
        <VideoBg autoPlay loop muted playsInline src={Video} type="video/mp4" />
      </HeroBg>
      <HeroContent>
        <HeroH1> 
          <div className="animated-typing">
            <Typed
              strings={[
                "Software Solution",
                "Ihr IT-Partner für Sicherheit & Innovation"
              ]}
              typeSpeed={50}
              backSpeed={35}
              loop
            />
          </div>
        </HeroH1>
        <HeroP>
          Infrastruktur optimieren · Netzwerke absichern · IT einfach machen
        </HeroP>
        <HeroBtnWrapper>
          <Button
            to="contact"
            smooth={true}
            duration={500}
            spy={true}
            offset={-80}
            onMouseEnter={onHover}
            onMouseLeave={onHover}
            primary="true"
            dark="true"
          >
            Gratis IT-Check {hover ? <ArrowForward /> : <ArrowRight />}
          </Button>
        </HeroBtnWrapper>
      </HeroContent>
    </HeroContainer>
  );
};


